export default __webpack_public_path__ + "static/media/Question-Game-Banner.a6fc5cba.png";